module.exports = __webpack_public_path__ + "img/shixi02.f5af4b79.png";